import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { INDIAN_STATES } from "@/lib/states";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none__";

export function useZones() {
  const { actingOrgId } = useAuth();
  return useQuery({ queryKey: ["master", "zones", actingOrgId], queryFn: async () => (await api.get("/org/masters/zones")).data }).data || [];
}

// Picking a state fills the zone that covers it when no zone is chosen yet.
export function StateZoneFields({ value, onChange, testPrefix, disabled, labelClass = "", triggerClass = "mt-1" }) {
  const zones = useZones();
  const setState = (v) => {
    const code = v === NONE ? "" : v;
    const zoneOf = (c) => zones.find((z) => (z.state_codes || []).includes(c));
    const auto = zoneOf(code);
    const prevAuto = zoneOf(value.state_code);
    const keep = value.zone_id && (!prevAuto || prevAuto.id !== value.zone_id);
    onChange({ state_code: code, zone_id: keep ? value.zone_id : (auto ? auto.id : "") });
  };
  return (
    <>
      <div><Label className={labelClass}>State</Label>
        <Select value={value.state_code || NONE} onValueChange={setState} disabled={disabled}>
          <SelectTrigger className={triggerClass} data-testid={`${testPrefix}-state`}><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={NONE}>Not assigned</SelectItem>{INDIAN_STATES.map((s) => <SelectItem key={s.code} value={s.code}>{s.name}</SelectItem>)}</SelectContent>
        </Select></div>
      <div><Label className={labelClass}>Zone</Label>
        <Select value={value.zone_id || NONE} onValueChange={(v) => onChange({ state_code: value.state_code || "", zone_id: v === NONE ? "" : v })} disabled={disabled}>
          <SelectTrigger className={triggerClass} data-testid={`${testPrefix}-zone`}><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={NONE}>Not assigned</SelectItem>{zones.map((z) => <SelectItem key={z.id} value={z.id}>{z.name}</SelectItem>)}</SelectContent>
        </Select></div>
    </>
  );
}
